<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields.textColor"
                @change="e => (fields.textColor = e.target.value)"
              />
              <v-text-field v-model="fields.textColor" label="Text Color" :hide-details="true" />
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['background-section'].color"
                @change="e => (fields['background-section'].color = e.target.value)"
              />
              <v-text-field
                v-model="fields['background-section'].color"
                label="Background Color"
                :hide-details="true"
              />
            </div>
          </v-col>
        </v-row>

        <div class="mb-6 mt-6">
          <label class="label-input">Padding</label>
          <div class="group-item">
            <v-row>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Container content</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields['container-content'].showStyle" label="Show style" />
              </v-col>
              <v-col cols="12" md="8">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-content'].background"
                    @change="e => (fields['container-content'].background = e.target.value)"
                  />
                  <v-text-field
                    v-model="fields['container-content'].background"
                    label="Container background"
                    :hide-details="true"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px">
            <div style="display: flex; align-items: center; gap: 10px">
              <label class="label-input" style="margin-bottom: 0">Cards</label>
            </div>
            <v-btn small text color="primary" @click="handleAddCard">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Card</span>
            </v-btn>
          </div>

          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(card, cardIndex) in fields.wrapCards.listItem" :key="cardIndex">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Card {{ cardIndex + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveCard(cardIndex)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- Position + Image -->
                <div class="group-item mb-6">
                  <div class="mb-4">
                    <div class="mb-3 d-flex align-center" style="gap: 10px">
                      <v-select
                        :value="Number(card.rightCard.order) === 1 ? 1 : 2"
                        :items="postionOptions"
                        label="Position"
                        @change="v => handleChangePosition(v, cardIndex)"
                      />
                    </div>
                    <div class="mb-3">
                      <v-text-field v-model="card.rightCard.video" label="Right card video URL" />
                    </div>
                    <div class="video-preview">
                      <video v-if="card.rightCard.video" width="100%" height="auto" autoplay muted loop playsinline>
                        <source :src="card.rightCard.video" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>

                <!-- Left Card border + centerY -->
                <div class="mb-4">
                  <div class="group-item">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-checkbox v-model="card.leftCard.enableBorder" label="Enable border" />
                      </v-col>
                      <v-col cols="12" md="8" v-if="card.leftCard.enableBorder">
                        <div class="d-flex align-center gap-3">
                          <input
                            type="color"
                            style="width: 40px; height: 40px; margin-right: 12px"
                            :value="card.leftCard.colorBorder"
                            @change="e => (card.leftCard.colorBorder = e.target.value)"
                          />
                          <v-text-field v-model="card.leftCard.colorBorder" label="Border color" />
                        </div>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-checkbox v-model="card.leftCard.centerY" label="Style center Y" />
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- Rating -->
                <div class="mb-4">
                  <label class="label-input" style="font-size: 16px !important">Rating</label>
                  <div class="group-item">
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-rating
                          color="warning"
                          background-color="#c1c1c1"
                          empty-icon="mdi-star-outline"
                          full-icon="mdi-star"
                          hover
                          length="5"
                          size="35"
                          :value="card.reted.ratingStars"
                          @input="val => (card.reted.ratingStars = clampRatingStars(val))"
                        />
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field v-model="card.reted.ratingText" label="Text" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-checkbox v-model="card.reted.showRating" label="Show Rating" />
                      </v-col>
                      <v-col cols="12" md="8">
                        <div class="d-flex align-center gap-3" v-if="card.reted.showRating">
                          <input
                            type="color"
                            style="width: 40px; height: 40px; margin-right: 12px"
                            :value="card.reted.ratingTextColor"
                            @change="e => (card.reted.ratingTextColor = e.target.value)"
                          />
                          <v-text-field
                            v-model="card.reted.ratingTextColor"
                            label="Rating Text Color"
                            :hide-details="true"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- Content -->
                <div class="mb-4">
                  <label class="label-input" style="font-size: 16px !important">Content</label>
                  <ckeditor :editor="editor" v-model="card.cardContent" :config="editorConfig" />
                </div>

                <!-- Accordions -->
                <div class="mb-5">
                  <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px">
                    <div style="display: flex; align-items: center; gap: 10px">
                      <label class="label-input" style="margin-bottom: 0">Accordions</label>
                      <input type="checkbox" v-model="card.itemAccordions.dataShowAccordion" />
                    </div>
                    <v-btn small text color="primary" @click="handleAddAccordion(cardIndex)">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add Accordion</span>
                    </v-btn>
                  </div>

                  <v-expansion-panels accordion>
                    <v-expansion-panel v-for="(item, i) in card.itemAccordions.listItem" :key="i">
                      <v-expansion-panel-header>
                        <div class="d-flex justify-space-between align-center" style="width: 100%">
                          <span>Accordion {{ i + 1 }}</span>
                          <v-btn icon @click.stop="handleRemoveAccordion(cardIndex, i)">
                            <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-text-field v-model="item.title" label="Title" class="mb-2" />
                        <ckeditor :editor="editor" v-model="item.answer" :config="editorConfig" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <!-- Survey -->
                <div class="mb-5">
                  <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px">
                    <div style="display: flex; align-items: center; gap: 10px">
                      <label class="label-input" style="margin-bottom: 0">Survey</label>
                      <input type="checkbox" v-model="card.cardSurvey.show" />
                    </div>
                    <v-btn small text color="primary" @click="handleAddSurveyItem(cardIndex)">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add Item</span>
                    </v-btn>
                  </div>

                  <div class="group-item mb-4" v-if="card.cardSurvey.show">
                    <div class="d-flex align-center gap-3" style="margin-bottom: 10px">
                      <input
                        type="color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="card.cardSurvey.colorPercent"
                        @change="e => (card.cardSurvey.colorPercent = e.target.value)"
                      />
                      <v-text-field v-model="card.cardSurvey.colorPercent" label="Color Percent" :hide-details="true" />
                    </div>

                    <v-expansion-panels accordion>
                      <v-expansion-panel v-for="(surveyItem, i) in card.cardSurvey.listItem" :key="i">
                        <v-expansion-panel-header>
                          <div class="d-flex justify-space-between align-center" style="width: 100%">
                            <span>Survey {{ i + 1 }}</span>
                            <v-btn icon @click.stop="handleRemoveSurveyItem(cardIndex, i)">
                              <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <div class="wrap-product-form">
                            <v-text-field
                              outlined
                              v-model="surveyItem.percent"
                              label="Percent"
                              type="number"
                              min="0"
                              max="100"
                            />
                            <ckeditor :editor="editor" v-model="surveyItem.description" :config="editorConfig" />
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>

                <!-- Images Small -->
                <div class="mb-5">
                  <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px">
                    <div style="display: flex; align-items: center; gap: 10px">
                      <label class="label-input" style="margin-bottom: 0">Images Small</label>
                      <input type="checkbox" v-model="card['images-small'].show" />
                    </div>
                    <v-btn small text color="primary" @click="handleAddImageSmall(cardIndex)">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add Image</span>
                    </v-btn>
                  </div>
                  <div class="group-item">
                    <v-row>
                      <v-col v-for="(imgItem, i) in card['images-small'].listItem" :key="i" cols="6" md="3">
                        <div class="img-small-item">
                          <UploadImage
                            @callback="obj => handleUploadImageSmall(obj, cardIndex, i)"
                            :image="{ imageSrc: imgItem.img }"
                            :height="`100`"
                            :typeUpload="'image'"
                            @callbackDelete="() => handleRemoveImageSmall(cardIndex, i)"
                          />
                          <v-btn icon small class="img-small-delete" @click.stop="handleRemoveImageSmall(cardIndex, i)">
                            <v-icon size="16" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- Item with icon -->
                <div class="mb-5">
                  <div class="d-flex justify-space-between align-center" style="margin-bottom: 10px">
                    <div style="display: flex; align-items: center; gap: 10px">
                      <label class="label-input" style="margin-bottom: 0">Item With Icon</label>
                      <input type="checkbox" v-model="card.itemWithIcon.show" />
                    </div>
                    <v-btn small text color="primary" @click="handleAddItemWithIcon(cardIndex)">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add Item</span>
                    </v-btn>
                  </div>

                  <div class="group-item">
                    <v-expansion-panels accordion>
                      <v-expansion-panel v-for="(iconItem, i) in card.itemWithIcon.listItem" :key="i">
                        <v-expansion-panel-header>
                          <div class="d-flex justify-space-between align-center" style="width: 100%">
                            <span>Item {{ i + 1 }}</span>
                            <v-btn icon @click.stop="handleRemoveItemWithIcon(cardIndex, i)">
                              <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="mb-3">
                            <label class="label-input" style="font-size: 14px !important; margin-bottom: 6px"
                              >Icon</label
                            >
                            <UploadImage
                              @callback="obj => handleUploadItemWithIcon(obj, cardIndex, i)"
                              :image="{ imageSrc: iconItem.icon }"
                              :height="`100`"
                              :typeUpload="'image'"
                              @callbackDelete="() => handleRemoveItemWithIconIcon(cardIndex, i)"
                            />
                          </div>
                          <v-text-field v-model="iconItem.title" label="Title" class="mb-2" />
                          <v-text-field v-model="iconItem.description" label="Description" />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>

                <!-- Button -->
                <div class="mb-4">
                  <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                    <label class="label-input" style="margin-bottom: 0">Button</label>
                    <input type="checkbox" v-model="card.btnCard.showBtn" />
                  </div>

                  <div class="group-item">
                    <v-text-field v-model="card.btnCard.text" label="Button Text" />
                    <v-text-field v-model="card.btnCard.url" label="Button URL" />
                    <v-row>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center gap-3">
                          <input
                            type="color"
                            style="width: 40px; height: 40px; margin-right: 12px"
                            :value="card.btnCard.backgroundColor"
                            @change="e => (card.btnCard.backgroundColor = e.target.value)"
                          />
                          <v-text-field v-model="card.btnCard.backgroundColor" label="Button Background Color" />
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="d-flex align-center gap-3">
                          <input
                            type="color"
                            style="width: 40px; height: 40px; margin-right: 12px"
                            :value="card.btnCard.color"
                            @change="e => (card.btnCard.color = e.target.value)"
                          />
                          <v-text-field v-model="card.btnCard.color" label="Button Text Color" />
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';

const clamp = (val, min, max) => {
  const n = Number(val);
  if (!Number.isFinite(n)) return min;
  return Math.max(min, Math.min(max, Math.round(n)));
};

export default {
  name: 'CardMultiToolDoubleSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card Multi Tool Double Section',
        enableAnchor: false,
        textColor: '#000000',
        padding: { top: true, bottom: true },
        'background-section': { color: '#ffffff' },
        'container-content': { showStyle: false, background: '#ffffff' },
        wrapCards: {
          listItem: [
            {
              leftCard: { order: '1', centerY: false, enableBorder: true, colorBorder: '#d4dceb' },
              rightCard: { order: '2', video: '' },
              reted: { showRating: false, ratingStars: 4, ratingText: '', ratingTextColor: '#000000' },
              cardSurvey: { show: true, colorPercent: '#17d4f4', listItem: [{ percent: 0, description: '' }] },
              cardContent: '',
              itemAccordions: { dataShowAccordion: true, listItem: [] },
              'images-small': { show: true, listItem: [] },
              itemWithIcon: { show: true, listItem: [] },
              btnCard: {
                showBtn: true,
                backgroundColor: '#d4c4a8',
                color: '#ffffff',
                text: 'Learn more',
                url: '#',
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    const merged = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };

    // Ensure at least 1 card for a better editing experience.
    if (!merged.wrapCards) merged.wrapCards = { listItem: [] };
    if (!Array.isArray(merged.wrapCards.listItem)) merged.wrapCards.listItem = [];
    if (merged.wrapCards.listItem.length === 0) merged.wrapCards.listItem = this.fields.wrapCards.listItem;

    // Backward compatibility: ensure cardSurvey exists for older extracted HTML.
    merged.wrapCards.listItem = merged.wrapCards.listItem.map(card => {
      const defaultCard = this.makeDefaultCard();
      const cardSurvey = card?.cardSurvey || defaultCard.cardSurvey;
      const listItem = Array.isArray(cardSurvey?.listItem) ? cardSurvey.listItem : defaultCard.cardSurvey.listItem;
      // Backward compatibility: old HTML used rightCard.img, new HTML uses rightCard.video.
      const rightCard = {
        ...defaultCard.rightCard,
        ...(card?.rightCard || {}),
      };
      if (!rightCard.video && rightCard.img) {
        rightCard.video = rightCard.img;
      }
      delete rightCard.img;
      return {
        ...defaultCard,
        ...card,
        rightCard,
        cardSurvey: {
          ...defaultCard.cardSurvey,
          ...cardSurvey,
          listItem,
        },
      };
    });

    this.fields = merged;
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    clampRatingStars(val) {
      return clamp(val, 0, 5);
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardMultiToolDouble(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    makeDefaultCard() {
      return {
        leftCard: { order: '1', centerY: false, enableBorder: true, colorBorder: '#d4dceb' },
        rightCard: { order: '2', video: '' },
        reted: { showRating: false, ratingStars: 4, ratingText: '', ratingTextColor: '#000000' },
        cardSurvey: { show: true, colorPercent: '#17d4f4', listItem: [{ percent: 0, description: '' }] },
        cardContent: '',
        itemAccordions: { dataShowAccordion: true, listItem: [] },
        'images-small': { show: true, listItem: [] },
        itemWithIcon: { show: true, listItem: [] },
        btnCard: {
          showBtn: true,
          backgroundColor: '#d4c4a8',
          color: '#ffffff',
          text: 'Learn more',
          url: '#',
        },
      };
    },
    handleAddCard() {
      this.fields.wrapCards.listItem.push(this.makeDefaultCard());
    },
    handleRemoveCard(cardIndex) {
      this.fields.wrapCards.listItem.splice(cardIndex, 1);
    },
    handleChangePosition(value, cardIndex) {
      // 1 => image left (order 1), 2 => image right (order 2)
      const card = this.fields.wrapCards.listItem[cardIndex];
      if (!card) return;

      if (value === 1) {
        card.rightCard.order = '1';
        card.leftCard.order = '2';
      } else {
        card.rightCard.order = '2';
        card.leftCard.order = '1';
      }
    },
    handleAddAccordion(cardIndex) {
      this.fields.wrapCards.listItem[cardIndex].itemAccordions.listItem.push({ title: '', answer: '' });
    },
    handleRemoveAccordion(cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex].itemAccordions.listItem.splice(index, 1);
    },
    handleAddSurveyItem(cardIndex) {
      this.fields.wrapCards.listItem[cardIndex].cardSurvey.listItem.push({ percent: 0, description: '' });
    },
    handleRemoveSurveyItem(cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex].cardSurvey.listItem.splice(index, 1);
    },
    handleAddImageSmall(cardIndex) {
      this.fields.wrapCards.listItem[cardIndex]['images-small'].listItem.push({ img: '' });
    },
    handleUploadImageSmall(obj, cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex]['images-small'].listItem[index].img = obj.imageSrc;
    },
    handleRemoveImageSmall(cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex]['images-small'].listItem.splice(index, 1);
    },
    handleAddItemWithIcon(cardIndex) {
      this.fields.wrapCards.listItem[cardIndex].itemWithIcon.listItem.push({ icon: '', title: '', description: '' });
    },
    handleRemoveItemWithIcon(cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex].itemWithIcon.listItem.splice(index, 1);
    },
    handleUploadItemWithIcon(obj, cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex].itemWithIcon.listItem[index].icon = obj.imageSrc;
    },
    handleRemoveItemWithIconIcon(cardIndex, index) {
      this.fields.wrapCards.listItem[cardIndex].itemWithIcon.listItem[index].icon = '';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.img-small-item {
  position: relative;
}
.img-small-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #fff;
  border-radius: 50%;
}
</style>
